import { render, staticRenderFns } from "./ot-contract-setup-form.vue?vue&type=template&id=0f0fc998&scoped=true&"
import script from "./ot-contract-setup-form.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-setup-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-setup-form.vue?vue&type=style&index=0&id=0f0fc998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0fc998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VForm,VOverlay,VTooltip})
